import { envConfig } from '#constants/envConfig';

/**
 * Where "home" points on each surface.
 *
 * On the web home is the marketing landing — it is the page search engines rank and the
 * one that converts visitors. Inside the app that page is wrong in three ways: it sells
 * an app the person already installed (down to a Google Play button, which App Store
 * rules forbid outright), it is the main evidence for a "repackaged website" rejection,
 * and it is simply not what someone who opened the app came for.
 *
 * So in the native shell home is the product: the feed for a signed-in user, the sign-in
 * screen for everyone else. IS_NATIVE is a build-time constant, so the web keeps the
 * landing with no runtime branch at all.
 */
export const homeRoute = (isAuth: boolean) => {
  if (!envConfig.IS_NATIVE) {
    return '/{-$locale}' as const;
  }

  return isAuth ? ('/{-$locale}/dashboard' as const) : ('/{-$locale}/sign-in' as const);
};
